package horcrux.browserapp

import horcrux.browserapp.clients.AnalyticsClientImpl
import horcrux.browserapp.views.org.LandingPage
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.RouteObject
import horcrux.frontend.common.clients.AuthenticationClient
import horcrux.frontend.common.views.components.containers.AlertBanner
import horcrux.frontend.common.views.screens.ChatWithYourCollectionScreen
import horcrux.frontend.common.views.screens.ContactUsScreen
import horcrux.frontend.common.views.screens.ErrorBoundaryScreen
import horcrux.frontend.common.views.screens.LatestNewsScreen
import horcrux.frontend.common.views.screens.PrivacyPolicyScreen
import js.objects.jso
import mui.material.AlertColor
import react.FC
import react.Props
import react.create
import react.dom.client.createRoot
import react.router.RouterProvider
import react.router.dom.createHashRouter
import web.dom.document

val App = FC<Props> {
    val globalAppState = GlobalAppState(AnalyticsClientImpl(), AuthenticationClient())

    AlertBanner {
        this.alertBannerData = globalAppState.alertBannerState.get()
        this.timeoutOperation = { globalAppState.updateBanner(AlertColor.info, null) }
    }

    val hashRouter = createHashRouter(
        routes = arrayOf(jso {
            this.errorElement = ErrorBoundaryScreen.create {
                this.message = "There was an error loading this page. Please try hitting the back button."
                this.globalAppState = globalAppState
            }
            this.children = listOf(
                RouteObject(Route.LANDING_PAGE, LandingPage) {
                    this.globalAppState = globalAppState
                },
                RouteObject(Route.CHAT_WITH_YOUR_COLLECTION, ChatWithYourCollectionScreen) {
                    this.globalAppState = globalAppState
                },
                RouteObject(Route.CONTACT_US, ContactUsScreen) {
                    this.globalAppState = globalAppState
                },
                RouteObject(Route.LATEST_NEWS, LatestNewsScreen) {
                    this.globalAppState = globalAppState
                },
                RouteObject(Route.PRIVACY_POLICY, PrivacyPolicyScreen) {
                    this.globalAppState = globalAppState
                },
            ).toTypedArray()
        })
    )

    RouterProvider {
        this.router = hashRouter
    }
}

fun main() {
    val container = document.getElementById("root") ?: error("Couldn't find root container!")
    createRoot(container).render(horcrux.browserapp.App.create())
}
